import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  return (
    <footer className="bg-bahbrown border-t-2 border-bahyellow mt-10 text-white text-sm font-light">
      <div className="container mx-auto">

        {/* Newsletter CTA */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 py-10 border-b border-white/10">
          <div>
            <p className="text-bahyellow text-xs font-semibold uppercase tracking-widest mb-1">Newsletter</p>
            <h3 className="text-white text-xl font-semibold">Be the first to know about our events</h3>
            <p className="text-gray-400 text-sm mt-1">Stay up to date with upcoming events, news from the Hub, and updates from our members and partners.</p>
          </div>
          <a
            href="http://eepurl.com/c-4RcT"
            target="_blank"
            rel="noopener noreferrer"
            className="self-start inline-block shrink-0 bg-bahyellow text-black font-semibold px-7 py-3 rounded-full hover:brightness-95 transition-all text-sm"
          >
            Subscribe
          </a>
        </div>

        {/* Footer links & address */}
        <div className="flex flex-wrap justify-between py-8">
          <div className="w-1/2">
            <ul className="flex flex-col space-y-0.5">
              <li><Link to='/'>Home</Link></li>
              <li><Link to='/about-us'>About us</Link></li>
              <li><Link to='/events'>Events</Link></li>
              <li><Link to='/contact'>Contact</Link></li>
              <li><Link to='/join-us'>Join us</Link></li>
            </ul>
          </div>
          <div className="w-1/2 mb-3">
            <div className="flex items-center">
              <span className="font-semibold">Brussels-Africa Hub AISBL</span>
              <a href="https://www.linkedin.com/company/brussels-africa-hub/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} className="text-lg ml-4" />
              </a>
            </div>
            <i>International Non-Profit Organisation</i><br /><br />
            Avenue du Houx 18, Bus 2<br />
            1170 Watermael-Boitsfort, Belgium<br />
            BE 0682.586.426<br />
            <a href="mailto:info@brusselsafricahub.eu">info@brusselsafricahub.eu</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
